import type { SVGProps } from "react";
import { memo } from "react";
const Comprehend = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#055F4E" />
        <stop offset="100%" stopColor="#56C0A7" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M17 54h16v-2H17zm17-7h9v-2h-9zm-17 0h15v-2H17zm0-21h13v-2H17zm46.01 28.079c-.112.077-.257.139-.406.208-.528.247-1.251.586-1.542 1.364Q61 55.821 61 56v4h-2v-9h3v-2h-8v2h3v9h-2v-4a1 1 0 0 0-.063-.349c-.29-.778-1.013-1.117-1.541-1.364-.15-.069-.294-.131-.407-.208-2.964-2.055-4.445-5.574-3.864-9.183.648-4.033 4.08-7.275 8.162-7.708a15 15 0 0 1 1.426 0c4.08.433 7.514 3.675 8.162 7.708.58 3.609-.9 7.128-3.864 9.183m5.84-9.5c-.79-4.909-4.964-8.853-9.927-9.381a16 16 0 0 0-1.846 0h-.001c-4.962.528-9.137 4.472-9.926 9.381-.704 4.376 1.097 8.646 4.7 11.143.196.135.44.257.698.377.137.064.346.161.452.215V61a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-4.67c.12-.077.32-.169.452-.231.257-.12.502-.242.697-.377 3.604-2.497 5.405-6.767 4.7-11.143M59.465 66h-2.93l-.667-1h4.264zM62 63h-8a1 1 0 0 0-.832 1.555l2 3c.186.278.498.445.832.445h4c.334 0 .646-.167.832-.445l2-3A1.002 1.002 0 0 0 62 63M17 40h26v-2H17zm9-7h17v-2H26zm-9 0h7v-2h-7zm19-17.586L44.586 24H36zM46 61H14V14.005L34 14v11a1 1 0 0 0 1 1h11v12h2V25h-.01a1 1 0 0 0-.283-.707l-12-12A.99.99 0 0 0 35 12.01V12l-22 .005a1 1 0 0 0-1 1V62a1 1 0 0 0 1 1h34a1 1 0 0 0 1-1v-6h-2z"
      />
    </g>
  </svg>
);
const Memo = memo(Comprehend);
export default Memo;
